import { styled as t } from "styled-components";
import { MediaQuery as o } from "../../styles/variables.js";
const r = t.div`
  position: relative;
  width: fit-content;
  height: fit-content;

  @media ${o.SCREEN_SM} {
    margin-bottom: 12px;
  }
`;
export {
  r as DropdownWrapperContainer
};
